import _get from 'hs-lodash/get';
import _pick from 'hs-lodash/pick';
export const buildName = contact => {
  const firstName = _get(contact, 'firstName') || _get(contact, 'firstname');
  const lastName = _get(contact, 'lastName') || _get(contact, 'lastname');
  const email = _get(contact, 'email');
  if (!firstName && !lastName) {
    return email || '';
  }
  return `${firstName || ''} ${lastName || ''}`;
};
export const buildContactListFilters = () => {
  return [{
    operator: 'HAS_PROPERTY',
    propertyName: 'email'
  }];
};
export const transformContacts = contacts => {
  if (!Array.isArray(contacts)) return [];
  return contacts.map(contact => Object.assign({
    id: contact.id
  }, _pick(contact.properties, ['firstname', 'lastname', 'email', 'photo'])));
};
export const formatParticipant = participant => {
  const name = 'screenName' in participant ? participant.screenName : participant.userName || '';
  const [firstName, lastName] = name.split(' ');
  const contact = _get(participant, 'contact', {});
  const isAutoMapped = _get(participant, 'isAutoMapped', false);
  return {
    participantId: 'participantUUID' in participant ? participant.participantUUID : participant.participantId,
    firstName,
    lastName,
    contact,
    isAutoMapped
  };
};